import { useState } from 'react'
import useInit from './hooks/useInit'
import DeleteModal from 'shared/components/DeleteModal'
import { apiUrls, roles, tableColumnWidths } from 'consts'
import getRows from './utils/getRows'
import { SearchState, SortingState } from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableColumnResizing,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import AddComment from './addComment'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface CommentsProps {
  id: string
}

const Comments: React.FunctionComponent<CommentsProps> = ({ id }: CommentsProps) => {
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)
  const [dependency, setDependency] = useState<number>(0)

  const canAddComment = hasAnyRole([roles.admin, roles.superAdmin])

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'text', title: 'Comment / Note' },
    { name: 'date', title: 'Time' },
    { name: 'user', title: 'User' },
    { name: 'action', title: 'Actions', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'text', width: 'auto' },
    { columnName: 'date', width: 'auto' },
    { columnName: 'user', width: 'auto' },
    { columnName: 'action', width: tableColumnWidths.action },
  ]

  const configuredGetRows = () => {
    return getRows({
      deviceId: id,
      setDeleteEntryId: setDeleteEntryId,
      setShowModal: setShowModal,
    })
  }

  useInit({
    getRows: configuredGetRows,
    setRows,
    setDeleteEntryId,
    setShowModal,
    dependency,
  })

  return (
    <>
      {' '}
      <h2>Comments / Notes</h2>
      <Grid rows={rows} columns={columns}>
        <SortingState defaultSorting={[{ columnName: 'date', direction: 'asc' }]} />
        <SearchState defaultValue='' />
        <Table />
        <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
        <TableHeaderRow showSortingControls />
      </Grid>
      <DeleteModal
        url={apiUrls.comments}
        showModal={showModal}
        setShowModal={setShowModal}
        deleteEntryId={deleteEntryId}
        setDeleteEntryId={setDeleteEntryId}
        entityName='Comment'
        getRows={configuredGetRows}
        setRows={setRows}
      />
      {canAddComment && (
        <AddComment id={id} dependency={dependency} setDependency={setDependency} />
      )}
    </>
  )
}

export default Comments
